import { onBeforeUnmount, ref } from 'vue';

export function usePoseRotator(count, intervalMs = 3400) {
  const active = ref(0);
  const rotation = ref(0);
  const step = 360 / count;
  let timer = null;

  function goTo(index) {
    const diff = (((index - active.value) % count) + count) % count;
    const shortest = diff > count / 2 ? diff - count : diff;
    rotation.value -= shortest * step;
    active.value = index;
  }

  function next() {
    goTo((active.value + 1) % count);
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function start() {
    stop();
    timer = setInterval(next, intervalMs);
  }

  function select(index) {
    goTo(index);
    start();
  }

  onBeforeUnmount(stop);
  return { active, rotation, select, start, stop };
}
